import { Link } from "react-router-dom";
import { announcements, siteIntro } from "@/mocks/catalog";
import { allItems } from "@/utils/catalog";

export default function SiteIntro() {
  const stats = [
    { icon: "ri-film-line", value: `${allItems.length}+`, label: "收录影视" },
    { icon: "ri-list-check-2", value: "3", label: "内容分类" },
    { icon: "ri-user-star-line", value: "50万+", label: "月活观众" },
    { icon: "ri-calendar-check-line", value: "每日", label: "内容更新" },
  ];

  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">
        <div>
          <div className="flex items-center gap-3 mb-6">
            <span className="w-1.5 h-7 rounded-full bg-primary-500"></span>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950">
              {siteIntro.title}
            </h2>
          </div>
          <div className="space-y-4">
            {siteIntro.paragraphs.map((p) => (
              <p key={p.slice(0, 12)} className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {p}
              </p>
            ))}
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8">
            {stats.map((s) => (
              <div key={s.label} className="rounded-lg bg-background-100 border border-background-200 p-4">
                <i className={`${s.icon} text-2xl text-primary-500`}></i>
                <p className="mt-2 text-xl font-black text-foreground-950">{s.value}</p>
                <p className="text-xs text-foreground-500 mt-0.5">{s.label}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="rounded-lg border border-background-200 bg-background-100 p-6">
          <h3 className="text-base font-bold text-foreground-950 mb-4 flex items-center gap-2">
            <i className="ri-megaphone-line text-accent-500"></i>
            站内公告
          </h3>
          <ul className="space-y-4">
            {announcements.map((n) => (
              <li key={n.id} className="flex items-start gap-3">
                <span className="shrink-0 mt-0.5 px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900 text-xs font-medium">
                  {n.tag}
                </span>
                <p className="text-sm text-foreground-600 leading-relaxed">{n.text}</p>
              </li>
            ))}
          </ul>
          <div className="mt-6 pt-6 border-t border-background-200">
            <p className="text-sm text-foreground-500 leading-relaxed mb-4">
              想了解豆花视频的定位、服务范围与联系方式？前往关于页查看更多信息。
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              了解豆花视频
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}